import { withInstall } from '@vuesax-plus/utils'
import ButtonGroup from './src/button-group.vue'

export const VsButtonGroup = withInstall(ButtonGroup)
export default VsButtonGroup

export * from './src/button-group'
